<div class="row">
  <div class="col-3 border-end d-flex flex-column">
    <div class="fw-bold fs-5 text-uppercase ms-3 mt-3" style="color: #f79421;">
      {{ 'galleryOnboardingChecklist.yourSetupChecklist' | transloco }}
    </div>
    <ul class="dsMenu ms-2 px-2">
      @for (item of gallerymenuList; track item; let i = $index) {
<li [id]="item.id" class="checklist-item" [ngClass]="{
                'active': currentIndex === i,
                'completed': completedSteps.includes(item.id) && currentIndex !== i
              }" (click)="isItemClickable(i) && navigateTo(item.id)">
          {{ item.label }}
        </li>
      }
    </ul>
  </div>

  <div class="col-9">
    <hr class="mb-2">
    <!-- step-1 -->
    @if (currentIndex === 0) {
      <div class="dsDescription">
        <h3 class="fs-4 mt-2 mb-2">{{ 'galleryOnboardingChecklist.addFirstArtworkTitle' | transloco }}</h3>
        <p>{{ 'galleryOnboardingChecklist.addFirstArtworkIntro' | transloco }}</p>
        <ul class="dsList ms-3 px-3 mb-2">
          <li>{{ 'galleryOnboardingChecklist.uploadFirstItem' | transloco }}</li>
          <li>{{ 'galleryOnboardingChecklist.findPhoto' | transloco }}</li>
          <li>{{ 'galleryOnboardingChecklist.giveItName' | transloco }}</li>
          <li>{{ 'galleryOnboardingChecklist.saveIt' | transloco }}</li>
          <li>{{ 'galleryOnboardingChecklist.congratulations' | transloco }}</li>
        </ul>
        <div class="dsMobileImages mt-2">
          <img src=" assets/images/hip-flask-2.jpg" alt="">
        </div>
        <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
          <button class="btn btn-outline-secondary" routerLink="/">{{ 'galleryOnboardingChecklist.skip' | transloco }}</button>
          <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">{{ 'galleryOnboardingChecklist.saveAndNext' | transloco }}</button>
        </div>
      </div>
    }
    <!-- step-2 -->
    @if (currentIndex === 1) {
      <div class="dsDescription">
        <div class="col-sm-12 mt-2 mb-2 ">
          <app-onboarding-gallery-personal-details (onSave)="SaveUpdatedUser($event)">
          </app-onboarding-gallery-personal-details>
        </div>
      </div>
    }
    <!-- step-3 -->
    @if (currentIndex === 2) {
      <div class="dsDescription">
        <h3 class="fs-5">{{ 'galleryOnboardingChecklist.howGalleriesUse' | transloco }}</h3>
        <div class="fs-6 mb-2">{{ 'galleryOnboardingChecklist.demonstrationsHelp' | transloco }}</div>
        <ol class="list-group mb-2">
          <li class="list-group-item">{{ 'galleryOnboardingChecklist.learnLayout' | transloco }}</li>
          <li class="list-group-item">{{ 'galleryOnboardingChecklist.howToUploadGallery' | transloco }}</li>
          <li class="list-group-item">{{ 'galleryOnboardingChecklist.howToConnectArtist' | transloco }}</li>
          <li class="list-group-item">{{ 'galleryOnboardingChecklist.howToAcceptProposal' | transloco }}</li>
          <li class="list-group-item">{{ 'galleryOnboardingChecklist.viewDispatchDocs' | transloco }}</li>
          <li class="list-group-item">{{ 'galleryOnboardingChecklist.marketArtworks' | transloco }}</li>
        </ol>
        <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
          <button class="btn btn-outline-secondary" routerLink="/">{{ 'galleryOnboardingChecklist.skip' | transloco }}</button>
          <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">{{ 'galleryOnboardingChecklist.saveAndNext' | transloco }}</button>
        </div>
      </div>
    }
    <!-- step-4 -->
    @if (currentIndex === 3) {
      <div class="dsDescription">
        <!-- work here -->
        <connected-artists></connected-artists>
        <!-- <div class="table-responsive mt-3">
        <p-table #dt [value]="connectedArtist" dataKey="gallery-connection" [rowHover]="true"
          styleClass="p-datatable-gridlines p-datatable-striped"
          [globalFilterFields]="['Name','Email', 'PhoneNumber', 'BusinessName']" selectionMode="single"
          [paginator]="connectedArtist.length > 15" [rows]="10" [reorderableColumns]="true" [resizableColumns]="false">
          <ng-template pTemplate="caption">
            <div class="table-header">
              <div class="row">
                <div class="col-md-6 text-right">
                  <div
                    class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                    <button type="button"
                      class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                      <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                    </button>
                    <input type="text"
                      class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                      (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="Search..." />
                    </div>
                  </div>
                  <div class="col-md-6 text-left"></div>
                </div>
              </div>
            </ng-template>
            <ng-template let-rowIndex="rowIndex" pTemplate="header" let-rowData>
              <tr>
                <th [pSortableColumn]="'Name'">
                  Artist <p-sortIcon [field]="'Name'"></p-sortIcon>
                </th>
                <th class="text-center" [pSortableColumn]="'InvitedOn'" style="width: 180px;">
                  Invited <p-sortIcon [field]="'InvitedOn'"></p-sortIcon>
                </th>
                <th class="text-center" [pSortableColumn]="'Accepted'" style="width: 180px;">
                  Accepted <p-sortIcon [field]="'Accepted'"></p-sortIcon>
                </th>
                <th class="text-center" style="width: 300px;">Actions</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
              <tr>
                <td>
                  <div class="d-flex">
                    <img [src]="rowData.ImgUrl ? rowData.ImgUrl : 'assets/images/No-Image.png'" width="45"
                      class="rounded-circle cursor-pointer" />
                      <div class="ms-2">
                        <div class="d-flex justify-content-start align-items-center">
                          <a href="javascript:void(0);" (click)="navigateToViewArtist(rowData)">
                            {{rowData.Name}}
                          </a>
                          <i class="fa fa-check-circle text-success ms-2" *ngIf="rowData.IsInviteAccepted"
                          pTooltip="Accepted"></i>
                          <i class="fa fa-check-circle text-danger ms-2"
                          *ngIf="!rowData.IsInitiatedByArtist && !rowData.IsInviteAccepted" pTooltip="sent"></i>
                          <i class="fa fa-clock-o text-danger ms-2"
                          *ngIf="rowData.IsInitiatedByArtist && !rowData.IsInviteAccepted" pTooltip="Pending"></i>
                        </div>
                        <div class="text-muted small">{{rowData.Email}}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="text-center" *ngIf="rowData.CreatedDate">{{rowData.CreatedDate | date: 'dd-MMM-yyyy HH:mm'}}
                    </div>
                  </td>
                  <td>{{rowData.InvitationAccepted | date: 'dd/MM/yyyy HH:mm'}}</td>
                  <td *ngIf="!authConfig.IsGalleryStaff">
                    <div class="d-flex justify-content-end align-items-center" *ngIf="rowData.InvitationAccepted">
                      <p-button type="button" icon="fa fa-briefcase" label=" Artworks" class="ms-2" [outlined]="true"
                      size="small" (click)="navigateToViewArtist(rowData)"></p-button>
                      <p-button type="button" icon="fa fa-comments" label="Chat" class="ms-2" [outlined]="true" size="small"
                        (click)="ChatwithArtist(rowData)">
                      </p-button>
                    </div>
                    <div class="d-flex justify-content-end align-items-center"
                      *ngIf="rowData.IsInitiatedByArtist && !rowData.IsInviteAccepted">
                      <p-button type="button" icon="fa fa-external-link" label="View Request" [outlined]="true" size="small"
                      (click)="goToConnectionRequestDetail(rowData)"></p-button>
                    </div>
                    <div class="d-flex justify-content-end align-items-center"
                      *ngIf="!rowData.InvitationAccepted && !rowData.IsInitiatedByArtist">
                      <p-button type="button" icon="fa fa-external-link" label="View Profile" [outlined]="true" class="ms-1"
                      size="small" (click)="navigateToViewArtist(rowData)"></p-button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="6">
                    <div class="text-center">No connection(s) found.</div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div> -->
          <!-- work here -->
          <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
            <button class="btn btn-outline-secondary" routerLink="/">{{ 'galleryOnboardingChecklist.skip' | transloco }}</button>
            <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">{{ 'galleryOnboardingChecklist.saveAndNext' | transloco }}</button>
          </div>
        </div>
      }
      <!-- step-5 -->
      @if (currentIndex === 4) {
        <div class="dsDescription">
          <h3 class="fs-4 mb-3">{{ 'galleryOnboardingChecklist.socialMediaTitle' | transloco }}</h3>
          <div>{{ 'galleryOnboardingChecklist.socialMediaIntro' | transloco }}
          </div>
          <ul class="dsList ms-3 px-3 mt-3">
            <li>{{ 'galleryOnboardingChecklist.addSocialAccounts' | transloco }}
              <div class="dsImage justify-content-center text-center">
                <img src="assets/images/socials.png" [alt]="'galleryOnboardingChecklist.socialsAlt' | transloco">
              </div>
            </li>
            <li>{{ 'galleryOnboardingChecklist.useShareButton' | transloco }}
              <div class="dsImage ms-3 px-4">
                <img src="assets/images/share.png" [alt]="'galleryOnboardingChecklist.shareAlt' | transloco">
              </div>
            </li>
            <li>{{ 'galleryOnboardingChecklist.facebookInstagramIntegration' | transloco }}
              <div class="dsImage ms-3 px-4">
                <img src="assets/images/connect.png" alt="" style="width: 100%; height: auto;">
              </div>
            </li>
            <li>{{ 'galleryOnboardingChecklist.publishPostsDirectly' | transloco }}
              <div class="dsImage ms-3 px-4">
                <img src="assets/images/post.jpg" alt="" style="width: 100%; height: auto;">
              </div>
            </li>
            <li clas>
              <h4>{{ 'galleryOnboardingChecklist.howToShareArtwork' | transloco }}</h4>
              <video src="video/social-share.mp4" controls class="dsVideo ms-3 px-4"></video>
            </li>
          </ul>
          <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
            <button class="btn btn-outline-secondary" routerLink="/">{{ 'galleryOnboardingChecklist.skip' | transloco }}</button>
            <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">{{ 'galleryOnboardingChecklist.saveAndNext' | transloco }}</button>
          </div>
        </div>
      }
      <!-- step-6 -->
      @if (currentIndex === 5) {
        <div class="dsDescription">
          <h3 class="fs-4 mt-2 mb-2">{{ 'galleryOnboardingChecklist.mobileAppsTitle' | transloco }}</h3>
          <p>{{ 'galleryOnboardingChecklist.mobileAppsIntro' | transloco }}</p>
          <ul class="dsMobileList ms-3 px-2 mb-2 mt-2">
            <li>{{ 'galleryOnboardingChecklist.haveIphone' | transloco }}<br />
              <a href="#"><img src="assets/images/iphone.png" alt=""></a>
            </li>
            <li>{{ 'galleryOnboardingChecklist.haveAndroid' | transloco }}<br />
              <a href="#"><img src="assets/images/android.png" alt=""></a>
            </li>
          </ul>
          <div class="dsMobileImages">
            <div class="row">
              <div class="col-4">
                <img src="assets/images/mobile/01-login.jpg" alt="">
              </div>
              <div class="col-4">
                <img src="assets/images/mobile/02-A Creative Artist.jpg" alt="">
              </div>
              <div class="col-4">
                <img src="assets/images/mobile/03-detail.jpg" alt="">
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <img src="assets/images/mobile/04-image-edit.jpg" alt="">
              </div>
              <div class="col-4">
                <img src="assets/images/mobile/05-import-images.jpg" alt="">
              </div>
              <div class="col-4">
                <img src="assets/images/mobile/06-filter-items.jpg" alt="">
              </div>
            </div>
            <img src="assets/images/mobile/07-profile.jpg" alt="">
          </div>
          <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
            <button class="btn btn-outline-secondary" routerLink="/">{{ 'galleryOnboardingChecklist.skip' | transloco }}</button>
            <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">{{ 'galleryOnboardingChecklist.saveAndNext' | transloco }}</button>
          </div>
        </div>
      }
      <!-- step-6  -->
      @if (currentIndex === 6) {
        <div class="dsDescription">
          <h3 class="fs-5">{{ 'galleryOnboardingChecklist.howArtistsUse' | transloco }}</h3>
          <div class="fs-6 mb-2">{{ 'galleryOnboardingChecklist.demonstrationsHelp' | transloco }}</div>
          <ol class="list-group  mb-2 ">
            <li class="list-group-item">{{ 'galleryOnboardingChecklist.learnLayout' | transloco }}</li>
            <li class="list-group-item">{{ 'galleryOnboardingChecklist.howToUploadArtist' | transloco }}</li>
            <li class="list-group-item">{{ 'galleryOnboardingChecklist.howToConnectGallery' | transloco }}</li>
            <li class="list-group-item">{{ 'galleryOnboardingChecklist.createFirstProposal' | transloco }}</li>
            <li class="list-group-item">{{ 'galleryOnboardingChecklist.creatingDispatchDocs' | transloco }}</li>
            <li class="list-group-item">{{ 'galleryOnboardingChecklist.marketingArtworks' | transloco }}</li>
          </ol>
            <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
            <button class="btn btn-outline-secondary" routerLink="/">{{ 'galleryOnboardingChecklist.skip' | transloco }}</button>
            <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">{{ 'galleryOnboardingChecklist.saveAndNext' | transloco }}</button>
          </div>
        </div>
      }
      <!-- step-8 -->
      @if (currentIndex === 7) {
        <div class="text-center">
          <div class="dsDescription">
            <!-- Contact 1 - Bootstrap Brain Component -->
            <section class="py-3">
              <div class="container">
                <div class="row justify-content-md-center">
                  <div class="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                    <h2 class="text-center fs-4">{{ 'galleryOnboardingChecklist.contact' | transloco }}</h2>
                    <div class="text-center">{{ 'galleryOnboardingChecklist.contactIntro' | transloco }}</div>
                    <hr class="w-50 mx-auto mb-4 mb-xl-9 border-dark-subtle">
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="row justify-content-lg-center">
                  <div class="col-12 col-lg-9">
                    <div class="bg-white border rounded shadow-sm overflow-hidden">
                      <form action="#!">
                        <div class="row gy-4 gy-xl-5 p-4 p-xl-5">
                          <div class="col-12">
                            <label for="fullname" class="form-label">{{ 'galleryOnboardingChecklist.fullName' | transloco }} <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" id="fullname" name="fullname" value="" required>
                          </div>
                          <div class="col-12 col-md-6">
                            <label for="email" class="form-label">{{ 'galleryOnboardingChecklist.email' | transloco }} <span class="text-danger">*</span></label>
                            <div class="input-group">
                              <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                  class="bi bi-envelope" viewBox="0 0 16 16">
                                  <path
                                    d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                                  </svg>
                                </span>
                                <input type="email" class="form-control" id="email" name="email" value="" required>
                              </div>
                            </div>
                            <div class="col-12 col-md-6">
                              <label for="phone" class="form-label">{{ 'galleryOnboardingChecklist.phoneNumber' | transloco }}</label>
                              <div class="input-group">
                                <span class="input-group-text">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-telephone" viewBox="0 0 16 16">
                                    <path
                                      d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                    </svg>
                                  </span>
                                  <input type="tel" class="form-control" id="phone" name="phone" value="">
                                </div>
                              </div>
                              <div class="col-12">
                                <label for="message" class="form-label">{{ 'galleryOnboardingChecklist.message' | transloco }} <span class="text-danger">*</span></label>
                                <textarea class="form-control" id="message" name="message" rows="3" required></textarea>
                              </div>
                              <div class="col-12">
                                <div class="d-grid">
                                  <button class="btn btn-primary btn-lg" type="submit">{{ 'galleryOnboardingChecklist.submit' | transloco }}</button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
                <button class="btn btn-outline-secondary" routerLink="/">{{ 'galleryOnboardingChecklist.skip' | transloco }}</button>
                <button class="btn btn-outline-secondary" (click)="saveAndAdvance()" routerLink="/">{{ 'galleryOnboardingChecklist.complete' | transloco }}</button>
              </div>
            </div>
          }
        </div>
      </div>